import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from '_common/hooks';

import {
  getDocumentObject,
  selectReadOnlyMode,
  documentAddKeyword,
  documentRemoveKeyword,
} from 'Editor/redux/EditorStatusSlice';

import { Tag, Select, SelectOption } from '@ets/design-system';

import styles from './KeywordSystem.module.scss';

const KeywordSystem = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { keywords, ...docObject } = useSelector(getDocumentObject);
  const keywordsArray: string[] = keywords;
  const disabled = useSelector(selectReadOnlyMode);

  const handleRemoveKeyword = (value: string) => {
    if (value) {
      dispatch(
        documentRemoveKeyword({ documentId: docObject.id, keywordIndex: keywords.indexOf(value) }),
      );
    }
  };

  const checkPermissions = () =>
    docObject.user_permissions.includes('owner') ||
    docObject.user_permissions.includes('edit') ||
    docObject.user_permissions.includes('admin');

  return (
    <div className={styles.root}>
      <div className={styles.inputContainer}>
        <Select
          size="l"
          variant="standard"
          width="100%"
          isCreatable={checkPermissions()}
          menuPosition="fixed"
          disabled={disabled || !checkPermissions()}
          menuPlacement={
            docObject.events && (docObject.events.due || docObject.events.warnings.length > 0)
              ? 'top'
              : 'bottom'
          }
          value={null} //Force select UI cleanup by sending null
          onChange={(values) => {
            if (values && (values as SelectOption).value) {
              dispatch(
                documentAddKeyword({
                  documentId: docObject.id,
                  keywordValue: (values as SelectOption).value,
                }),
              );
            }
          }}
          placeholder={intl.formatMessage({
            id: 'SELECT_KEYWORDS',
          })}
          formatCreateLabel={(label: string) =>
            `${intl.formatMessage({
              id: 'KEYWORD_SYSTEM_CREATE_KEYWORD',
            })} "${label}"`
          }
          noOptionsMessage={({ inputValue }: { inputValue: string }) =>
            inputValue === '' ? null : intl.formatMessage({ id: 'global.noResults' })
          }
          testId="keywords"
        />
      </div>

      {keywordsArray && keywordsArray.length >= 0 && (
        <div className={styles.tag}>
          {keywordsArray.map((keyword) => (
            <Tag
              key={keyword}
              label={keyword}
              variant="primary"
              size="m"
              onClick={checkPermissions() ? () => handleRemoveKeyword(keyword) : undefined}
              margin="0 1rem 1rem 0"
              testId={`keywords-${keyword}`}
            ></Tag>
          ))}
        </div>
      )}
    </div>
  );
};

export default KeywordSystem;
